import React, {Component} from 'react'
import { Divider, Popup } from 'semantic-ui-react'

class DocsGetURLParameters extends Component {
    render() {
        return (
            <div>
                <h5 id="parameterHeading">URL Query Parameters</h5>
                <Divider/>
                <span className="parameterName">fileID</span> <span className="parameterType">integer</span>
                <span className="parameterSecondLine"><span className="parameterRequired">Required</span></span>
                <span className="parameterDesc">This is the id of the spreadsheet imported through the web app. It can be found
                    <Popup content={<img src="https://images2.imgbox.com/62/6d/N2t6SsyE_o.png" alt="File ID"/>} trigger={<span className="linkStyle"> here</span>} />
                </span>
                <Divider/>
                <span className="parameterName">accessKey</span> <span className="parameterType">string, 32 characters</span>
                <span className="parameterSecondLine"><span className="parameterRequired">Required, if private</span> </span>
                <span className="parameterDesc">The accessKey of the file, if the API is private. If file is not private, then there is no need for the accessKey parameter</span>
                <Divider/>
                <span className="parameterName">secretKey</span> <span className="parameterType">string, 32 characters</span>
                <span className="parameterSecondLine"><span className="parameterRequired">Required, if private</span> </span>
                <span className="parameterDesc">The secretKey of the file, if the API is private. If file is not private, then there is no need for the secretKey parameter</span>
                <Divider/>
                <span className="parameterName">dataFormat</span> <span className="parameterType">string</span>
                <span className="parameterSecondLine"><span className="parameterOptional">Optional</span> <span className="parameterDefault">default=jsonRow</span></span>
                <span className="parameterDesc">The format of the output data you want, can be one of the following <code>jsonRow, matrix, jsonColumn</code>. If this parameter is not specified or is not in the aforementioned list, then the jsonRow format is returned.</span>
            </div>
        )
    }
}

export default DocsGetURLParameters